module.exports = __webpack_public_path__ + "img/icon_map_37_on_111.5cc905f2.png";